import { Stack } from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import pubsub from '../../../../../modules/pubsub'
import { IInventoryItemBrand } from '../../../../../shared/types'
import Spreadsheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import AddProductBrandForm from './forms/AddProductBrandForm'
import ExportProductBrandsForm from './forms/ExportProductBrandsForm'
import PageHeader from './PageHeader'
import PageContent from './page_content'



export default function Main() {

    const [isExportModalOpen, setIsExportModalOpen] = useState(false)
    const [isAddModalOpen, setIsAddModalOpen] = useState(false)

    

    const handleOnHeaderBtnSecondaryClick =()=>{
        setIsExportModalOpen(isExportModalOpen ? false : true)
    }

    const handleOnHeaderBtnPrimaryClick =()=>{
        setIsAddModalOpen(isAddModalOpen ? false : true)
    }

    const handleOnExport = (data:IInventoryItemBrand[])=>{

        if(data.length <= 0){
            // @ts-ignore
            toast("Error: No shops were created within the range you selected",
                // @ts-ignore
            {
                position: "top-center",
                type: "error",
                hideProgressBar: true,
                theme: "dark",
                // @ts-ignore
                duration: 5000  
            })
            return
        }

        const rows = ["Date created", "Name", "Gross profit", "Gross revenue", "Items in stock", "Cash in shop"]
        const cols:string[][] = [];

        data.forEach((brand)=>{
            const arr = [
                (new Date(brand.created_at)).toDateString(), 
                brand.name, 
                brand.gross_profit.toString(), 
                brand.gross_revenue.toString()
            ]
            cols.push(arr)
        })


        const aoa = [
            rows,
            ...cols
        ]

        Spreadsheet.aoaToSpreadSheet(aoa, "Brand list")
        setIsExportModalOpen(false)
        
        
    }

    const handleOnNewBrandAdded = ()=>{

        pubsub.trigger("brand-list:changed")
        setIsAddModalOpen(false)
        toast("New product brand added successfully.", {
            type: "success",
            theme: "dark",
            position: "top-center",
            hideProgressBar: true,
            autoClose: 5000
        })
        
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >

            <PageHeader onBtnPrimaryClick={handleOnHeaderBtnPrimaryClick} onBtnSecondaryClick={handleOnHeaderBtnSecondaryClick} />

            <PageContent />

            {/* Export modal */}
            <Modal
                title="Export sales history"
                subtitle="Select time range to export data"
                visible={isExportModalOpen}
                setVisibility={setIsExportModalOpen}
            >
                <ExportProductBrandsForm 
                    onDone={handleOnExport}
                    onFail={()=>{}}
                />
            </Modal>

            {/* Add Modal */}
            <Modal
                title="Add new product brand"
                subtitle="Please complete the form to add new product brand"
                visible={isAddModalOpen}
                setVisibility={setIsAddModalOpen}
            >
                <AddProductBrandForm 
                    onDone={handleOnNewBrandAdded}
                    onFail={()=>{}}
                />
            </Modal>


        </Stack>
    )

}
